import { bidlClient } from 'src/utils/api'
import { tryQuery } from 'src/utils/queries'

const baseUri = '/api/platform/markets/config/stonex/v1'

export type Configuration = {
  key: string
  value: string
}

export type UpdateOrCreateDatasourceConfigurationRequest = {
  datasourceId: string
  configurations: Configuration[]
}

export type DeleteDatasourceConfigurationRequest = {
  id: string
}

export type FindDatasourceConfigurationRequest = {
  id: string
}

export type ShowDatasourceWebhookConfigurationRequest = {
  id: string
}

export const GetDatasourceConfigurables = async (tenantId: string) =>
  tryQuery(
    bidlClient.post(
      `${baseUri}/GetDatasourceConfigurables`,
      {},
      { headers: { 'X-Bushel-Tenant': tenantId } }
    )
  )

export const UpdateOrCreateDatasourceConfiguration = async (
  data: UpdateOrCreateDatasourceConfigurationRequest,
  tenantId: string
) =>
  tryQuery(
    bidlClient.post(`${baseUri}/UpdateOrCreateDatasourceConfiguration`, JSON.stringify(data), {
      headers: {
        'Content-Type': 'application/json',
        'X-Bushel-Tenant': tenantId,
      },
    })
  )

export const DeleteDatasourceConfiguration = async (
  data: DeleteDatasourceConfigurationRequest,
  tenantId: string
) =>
  tryQuery(
    bidlClient.post(`${baseUri}/DeleteDatasourceConfiguration`, data, {
      headers: { 'X-Bushel-Tenant': tenantId },
    })
  )

export const FindDatasourceConfiguration = async (
  data: FindDatasourceConfigurationRequest,
  tenantId: string
) =>
  tryQuery(
    bidlClient.post(`${baseUri}/FindDatasourceConfiguration`, data, {
      headers: { 'X-Bushel-Tenant': tenantId },
    })
  )

export const GetDefaultDatasourceConfiguration = async (tenantId: string) =>
  tryQuery(
    bidlClient.post(
      `${baseUri}/GetDefaultDatasourceConfiguration`,
      {},
      { headers: { 'X-Bushel-Tenant': tenantId } }
    )
  )

export const ShowDatasourceWebhookConfiguration = async (
  data: ShowDatasourceWebhookConfigurationRequest,
  tenantId: string
) =>
  tryQuery(
    bidlClient.post(`${baseUri}/ShowDatasourceWebhookConfiguration`, data, {
      headers: { 'X-Bushel-Tenant': tenantId },
    })
  )
